<app-loader *ngIf="loading"></app-loader>
<!-- Overlay -->
<div *ngIf="open" class="fixed overlay inset-0 z-[100] grid place-items-center">
  <div class="absolute inset-0 bg-slate-900/60"></div>

  <!-- Modal -->
  <div
    class="relative w-[1150px]  h-[85vh] max-w-[95vw] rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200 px-5 py-2"
    role="dialog"
    aria-modal="true"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-6 pt-6">
        
      <h2
        id="ai-insights-title"
        class="2xl:text-2xl lg:text-xl md:text-[28px] leading-tight text-primary_Text_Color text-center"
      >
      <span *ngIf="displayedView=='EMPLOYEE_HISTORY'">Employee History |</span>
      <span *ngIf="displayedView=='MAPPED'">Mapped SRs |</span>
        {{ header.title }} - {{ header.empCode }}
      </h2>
      <div class="flex items-center gap-3">
        <!-- Tabs UI starts -->
        <div
          class="relative view-toggle inline-grid h-[58px] gap-2 w-[342px] max-w-full grid-cols-2 rounded-xl border border-[#E1E4EA] bg-white p-1 shadow-[0_1px_3px_0_rgba(15,23,42,0.12)] select-none"
          role="tablist"
          aria-label="View toggle"
        >
          <!-- Sliding highlight (50% width) -->
          <div
            class="view-toggle-indicator pointer-events-none absolute inset-y-1 left-1 w-[calc(50%-0.5rem)] rounded-lg border border-[#C8D2F0] bg-periwinkle_mist shadow-[0_1px_2px_0_rgba(15,23,42,0.08)]"
            [class.view-toggle-indicator--bench]="displayedView === allTabs[1].id"
          ></div>

          <button
            *ngFor="let tab of allTabs"
            type="button"
            class="relative z-10 text-nowrap rounded-lg border border-transparent px-4 text-xs 2xl:text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B8CBF7]"
            [ngClass]="
              displayedView === tab.id
                ? 'poppinsSemibold text-primary_Text_Color'
                : 'poppinsMedium text-my_profile_secondary_text hover:text-primary_Text_Color'
            "
            (click)="toggleView(tab.id)"
            role="tab"
            [attr.aria-selected]="displayedView === tab.id"
            [attr.aria-pressed]="displayedView === tab.id"
          >
            {{ tab.label }}
          </button>
        </div>
        <!-- Tabs UI ends -->
        <button
          type="button"
          class="ml-2 grid size-9 place-items-center rounded-full text-slate-500 hover:bg-slate-100"
          (click)="closeModal()"
          (mouseenter)="currentCloseImg = hoverCloseImg"
          (mouseleave)="currentCloseImg = defaultCloseImg"
          aria-label="Close dialog"
        >
          <img [src]="currentCloseImg" alt="crossIcon" />
        </button>
      </div>

    </div>

    <!-- Search -->
      <div
        class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between px-6 pb-4 pt-4"
      >
        <div class="flex flex-col md:flex-row md:items-center gap-3 w-full">
          <!-- Search -->
          <div class="flex w-full items-center gap-2">
            <div class="relative flex-1">
              <input
                [(ngModel)]="query"
                (ngModelChange)="onSearchChange($event)"
                (keydown.enter)="onSearch()"
                type="text"
                [placeholder]="this.displayedView=='MAPPED' ?'Find staffing requests with searches like “Grade 6 SRs in Mumbai” or “NLP skills' :'Search'"
                class="w-full outline-none ring-0 shadow-none  hoverShadow focus:border-primary_Bg_Button_Color rounded-xl border border-card_Bg_Color bg-white text-sm text-primary_Text_Color pr-4 pl-12 py-3.5 shadow-soft focus:outline-noneplaceholder:text-my_profile_secondary_text poppinsRegular"
              />
              <svg
                class="absolute left-4 top-1/2 -translate-y-1/2 size-6 text-my_profile_secondary_text"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="11"
                  cy="11"
                  r="7"
                  stroke="currentColor"
                  stroke-width="1.6"
                ></circle>
                <path
                  d="M20 20l-3.5-3.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                ></path>
              </svg>
            </div>

            <button
              class="shrink-0 px-6 py-3.5 rounded-xl text-white bg-primary_Bg_Button_Color shadow-[0px_0px_5px_1px_rgba(0,0,0,0.22)] text-sm poppinsMedium shadow-soft"
              (click)="onSearch()"
            >
              Search
            </button>

             <button  *ngIf="displayedView=='EMPLOYEE_HISTORY'"  type='button' (click)="downloadReportForEmployeeHistory()" class="cancel-button-animation flex shrink-0 items-center gap-2 px-6 py-4 bg-white text-primary_Text_Color poppinsMedium text-xs rounded-2xl border  transition-all duration-200 shadow-sm shadow-gray-200">       
                <!-- Document Download Icon -->
                <img [src]="_commonServices.Images.EXPORT_DOWNLOAD_ICON" alt="export download"  class="w-4"/>
                <span>Download</span>
            </button> 
          </div>
        </div>
      </div>

    <ng-container *ngIf="displayedView=='MAPPED'">
  
      <!-- Table -->
      <ng-container *ngIf="filteredRows?.length > 0; else nodata" class="px-4">
        <div class="">
          <!-- table header -->
          <div
            class="grid poppinsRegular border border-card_number_color grid-cols-[100px,130px,100px,130px,150px,120px,90px,90px,40px] items-center gap-2 rounded-t-xl bg-white p-5 text-xs text-my_profile_secondary_text  z-20"
          >
            <div (mouseenter)="hoveredSortColumn = 'srNumber'" (mouseleave)="hoveredSortColumn = null" class="flex cursor-pointer items-center gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('srNumber')">
              <span
                [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'srNumber' }"
              >SR ID</span>
              <img 
                [src]="activeSortColumn === 'srNumber' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'srNumber' ? hoverSortImg : defaultsortImg"
                [style.transform]="activeSortColumn === 'srNumber' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'"
                class="transition-transform duration-200"
                [ngClass]="activeSortColumn === 'srNumber'?'w-4 h-4':'w-3 h-3'"
                alt="sort"
              />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'aiMatchPercentage'" (mouseleave)="hoveredSortColumn = null" class="flex items-center gap-2 cursor-pointer w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('aiMatchPercentage')">
              <span
                [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'aiMatchPercentage' }"
              >iqigai Match %</span>
              <img 
                [src]="activeSortColumn === 'aiMatchPercentage' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'aiMatchPercentage' ? hoverSortImg : defaultsortImg"
                [style.transform]="activeSortColumn === 'aiMatchPercentage' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'"
                class="transition-transform duration-200"
                [ngClass]="activeSortColumn === 'aiMatchPercentage'?'w-4 h-4':'w-3 h-3'"
                alt="sort"
              />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'grade'" (mouseleave)="hoveredSortColumn = null" class="flex items-center cursor-pointer  gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('grade')">
              <span [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'grade' }">Grade</span>
              <img [src]="activeSortColumn === 'grade' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'grade' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'grade' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'" class="transition-transform duration-200"  [ngClass]="activeSortColumn === 'grade'?'w-4 h-4':'w-3 h-3'"  alt="sort" />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'costCentre'" (mouseleave)="hoveredSortColumn = null" class="flex items-center cursor-pointer  gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('costCentre')">
              <span [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'costCentre' }">Cost Centre</span>
              <img [src]="activeSortColumn === 'costCentre' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'costCentre' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'costCentre' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'" class="transition-transform duration-200"  [ngClass]="activeSortColumn === 'costCentre'?'w-4 h-4':'w-3 h-3'" alt="sort" />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'clientName'" (mouseleave)="hoveredSortColumn = null" class="flex items-center cursor-pointer  gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color"(click)="onSort('clientName')">
              <span [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'clientName' }">Client name</span>
              <img [src]="activeSortColumn === 'clientName' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'clientName' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'clientName' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'" [ngClass]="activeSortColumn === 'clientName'?'w-4 h-4':'w-3 h-3'" class="transition-transform duration-200" alt="sort" />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'city'" (mouseleave)="hoveredSortColumn = null" class="flex items-center cursor-pointer  gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('city')">
              <span  [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'city' }">City</span>
              <img [src]="activeSortColumn === 'city' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'city' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'city' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'" [ngClass]="activeSortColumn === 'city'?'w-4 h-4':'w-3 h-3'"  class="transition-transform duration-200" alt="sort" />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'ageing'" (mouseleave)="hoveredSortColumn = null" class="flex items-center cursor-pointer  gap-2 w-fit hoverOnSortingHeader hover:text-primary_Text_Color" (click)="onSort('ageing')">
              <span  [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'ageing' }">Ageing</span>
              <img [src]="activeSortColumn === 'ageing' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'ageing' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'ageing' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'"  [ngClass]="activeSortColumn === 'ageing'?'w-4 h-4':'w-3 h-3'" class="transition-transform duration-200" alt="sort" />
            </div>

            <div (mouseenter)="hoveredSortColumn = 'status'" (mouseleave)="hoveredSortColumn = null" class="cursor-pointer flex items-center gap-2" (click)="onSort('status')">
              <span  [ngClass]="{ 'text-primary_Bg_Button_Color': activeSortColumn === 'status' }">Status</span>
              <img [src]="activeSortColumn === 'status' ? _commonServices.Images.ASC_SORT : hoveredSortColumn === 'status' ? hoverSortImg : defaultsortImg" [style.transform]="activeSortColumn === 'status' && sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'" [ngClass]="activeSortColumn === 'status'?'w-4 h-4':'w-3 h-3'"  class="transition-transform duration-200" alt="sort" />
            </div>

            <div></div>
          </div>
  
          <!-- rows -->
          <div
            #candidateTableScrollContainer
            class="flex-1 xl:max-h-[49vh] 2xl:max-h-[60vh] overflow-auto"
            (scroll)="onTableScroll($event)"
          >
            <div
              *ngFor="let r of filteredRows; trackBy: trackById; let i = index; let isFirst = first;let isLast = last"
              class="rounded-xl"
            >
              <!-- SR row -->
               <!-- /* [ngClass]="isCardDisabled(r.employeeResponseDTO)?'bg-[#EAEBEF]':'bg-white'" */ -->
                    <!-- 'border-b': !isLast,
                   'rounded-t-xl  border-t': isFirst,
                   'rounded-b-xl border-b-0': isLast,  -->
              <div
              [ngClass]="{
                   'rounded-b-xl': isLast && filteredRows?.length !=1,
                   'bg-[#EAEBEF] ': isCardDisabled(r.employeeResponseDTO),
                   'bg-white hover:bg-[#F3F6FC]': !isCardDisabled(r.employeeResponseDTO)
             }" 
                class="grid border-b border-x  poppinsRegular grid-cols-[120px,110px,100px,140px,150px,110px,90px,80px,40px] items-center gap-2  p-4 text-xs text-primary_Text_Color"
              >
                <!-- SR ID link + role -->
                <div class="relative">
                  <div class="flex gap-2">
                    <a (click)="onClickSRId(r,i)"
                      class="text-xs poppinsMedium textBasedActions  cursor-pointer"
                      href="javascript:void(0)"
                      >{{ r.srId }}</a
                    >
                    <img *ngIf="r?.employeeResponseDTO.isRecommendedToPM"
                      (mouseenter)="showStarHover(r.srId)"
                      (mouseleave)="scheduleStarHide()"
                      [src]="_commonServices.Images.BLUE_INFO_CIRCLE_ICON"
                      alt=""
                    />
                  </div>
  
                  <!-- Hover modal (right side of star) -->
  
                  <div
                    *ngIf="isStarHoverForId === r.srId"
                    class="absolute -top-8 left-24 !z-50 w-[40rem] rounded-xl bg-white shadow-xl border border-card_Bg_Color p-6 poppinsMedium"
                    (mouseenter)="cancelStarHide()"
                    (mouseleave)="scheduleStarHide()"
                  >
                    <div
                      class="absolute left-[-6px] top-10 h-3 w-4 rotate-45 bg-white ring-1 ring-black/5"
                    ></div>
  
                    <div
                      class="grid grid-cols-3 gap-4 border-b border-card_Bg_Color text-xs text-slate-400 pb-3"
                    >
                      <div>Recommended by</div>
                      <div>Recommended to</div>
                      <div>Recommended on</div>
                    </div>
  
                    <div
                      class="grid grid-cols-3 gap-4 text-sm mt-4 text-primary_Text_Color"
                    >
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                        title="shamsher.rajan@fractal.ai"
                      >
                        shamsher.rajan@fractal.ai
                      </div>
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                      >
                        kaushik.madhusudan@fr…
                      </div>
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                      >
                        22nd December 2025
                      </div>
  
                      <div class="col-span-3 border-t border-card_Bg_Color"></div>
  
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                      >
                        shelja.jaiswal@fractal.ai
                      </div>
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                      >
                        sheila.jaiswal@fractal.ai
                      </div>
                      <div
                        class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                      >
                        3rd January 2026
                      </div>
                    </div>
                  </div>
  
                  <div class="mt-1 text-xxs text-slate-400 line-clamp-2 poppinsMedium">
                    {{ r.role }}
                  </div>
                </div>
  
                <div class="text-primary_Text_Color poppinsRegular">{{ r.candidate?.score | number: '1.0-2'  }}%</div>
  
                <div class="text-primary_Text_Color">{{ r.grade }}</div>
                <div class="text-primary_Text_Color leading-tight">
                  <div>{{ r.costCentreLine1 }}</div>
                </div>
                <div class="text-primary_Text_Color leading-tight">
                  <div>{{ r.clientName }}</div>
                </div>
                <div class="text-primary_Text_Color">{{ r.location }}</div>
                <div class="text-primary_Text_Color">{{ r.ageing }}</div>
                <div class="text-primary_Text_Color">{{ r.status }}</div>
  
                <div class="ml-auto flex items-center">
                  <button
                    class="grid size-8 place-items-center"
                    [attr.aria-expanded]="isOpen(r.id)"
                    [attr.aria-controls]="'row-' + r.id"
                    (click)="toggle(r.id)"
                  >
                    <img
                      [src]="_commonServices.Images.ACCORDIAN_ICON"
                      alt=""
                      class=""
                      [ngClass]="isOpen(r.id) ? 'rotate-180' : ''"
                    />
                  </button>
                </div>
              </div>
  
              <!-- Accordion row -->
              <div
                *ngIf="isOpen(r.id)"
                [id]="'row-' + r.id"
                class="transition"
                [ngClass]="isCardDisabled(r.employeeResponseDTO)?'bg-[#EAEBEF]':'bg-white'"
              >
                <div class="border-x border-b border-card_number_color" [ngClass]="filteredRows?.length==1?'rounded-b-xl':''">
                  <div class="grid grid-cols-12 gap-4 p-4">
                    <!-- Left profile card -->
                    <div class="col-span-12 md:col-span-5">
                      <div class="rounded-lg"
                      [ngClass]="isCardDisabled(r.employeeResponseDTO)?'bg-[#EAEBEF]':'bg-white'"
                      >
                         <div class="flex items-center gap-3 w-full">
                    <!-- User profile starts -->
                    <div>
                       <div
                        class="grid size-12 place-items-center rounded-full overflow-hidden ring-1 transition-colors font-semibold"
                        (mouseenter)="!isCardDisabled(r?.employeeResponseDTO) && (hoveredCandidateId = r?.employeeResponseDTO.employeeId)"
                        (mouseleave)="hoveredCandidateId = null"
                        (click)="!isCardDisabled(r?.employeeResponseDTO) && selectOnHover(r?.employeeResponseDTO)"
                        title="Select"
                        [ngClass]="{
                          'ring-slate-200 bg-slate-100': isCardDisabled(r?.employeeResponseDTO),
                          'cursor-not-allowed': isCardDisabled(r?.employeeResponseDTO),
                          'cursor-pointer': !isCardDisabled(r?.employeeResponseDTO),
                        }"
                      >
                        
                        <ng-container *ngIf="r?.profileUrl;else noAvatar">
                          <img
                            [src]="r?.profileUrl"
                            alt=""
                            class="size-full object-cover"
                          />
                        </ng-container>
                        <ng-template #noAvatar>
                          <div *ngIf="!r?.employeeResponseDTO.photoUrl">
                            {{ getInitial(r?.employeeResponseDTO?.employeeName) }}
                          </div>
                        </ng-template>
                      </div>
                    </div>
                     <!-- User profile starts -->
                     <div class="w-full">
                       <div class="flex items-center gap-3 w-full justify-between">
                         <div class="flex items-center gap-1 max-w-full">
                             <h3
                               class="text-lg poppinsMedium text-primary_Text_Color max-w-40 truncate whitespace-nowrap overflow-hidden text-ellipsis"
                               [title]="r.candidate.name"
                             >
                               {{ r.candidate.name }}
                             </h3>
                             <!-- <p class="poppinsMedium text-secondary_Light_Text_Color text-xs">Senior Software Developer</p> -->

                             <img
                               *ngIf="!isPMViewNavigation && r?.employeeResponseDTO?.isBlocked && !r?.employeeResponseDTO?.isCandidateSelected"
                               [src]="_commonServices.Images.BLOCK_CANDIDATE"
                               alt="Blocked candidate"
                               class="h-4 w-4"
                             />

                             <img
                               *ngIf="!isPMViewNavigation && r?.employeeResponseDTO?.isCandidateSelected"
                               [src]="_commonServices.Images.SELECTED_CANDIDATE"
                               alt="Selected candidate"
                               class="h-4 w-4"
                             />

                             <!-- star -->
                             <div
                               *ngIf="!isPMViewNavigation && r?.employeeResponseDTO?.isRecommendedToPM && !r?.employeeResponseDTO?.isBlocked"
                               class="relative inline-block"
                             >
                               <img
                                 [src]="_commonServices.Images.RECOMMENDED_CANDIDATE"
                                 alt="Recommended candidate"
                                 class="h-4 w-4 cursor-pointer"
                                 (mouseenter)="showStarHover(r?.employeeResponseDTO.employeeId)"
                                 (mouseleave)="scheduleStarHide()"
                               />
     
                               <!-- Hover modal (right side of star) -->
     
                               <div
                                 *ngIf="isStarHoverForId === r?.employeeResponseDTO?.employeeId"
                                 class="absolute -top-16 left-[calc(100%+10px)] z-50 w-[40rem] rounded-xl bg-white shadow-xl border border-card_Bg_Color p-6 poppinsMedium"
                                 (mouseenter)="cancelStarHide()"
                                 (mouseleave)="scheduleStarHide()"
                               >
                                 <div
                                   class="absolute left-[-6px] top-20 h-3 w-4 rotate-45 bg-white ring-1 ring-black/5"
                                 ></div>
     
                                 <div
                                   class="grid grid-cols-3 gap-4 border-b border-card_Bg_Color text-xs text-slate-400 pb-3"
                                 >
                                   <div>Recommended by</div>
                                   <div>Recommended to</div>
                                   <div>Recommended on</div>
                                 </div>
     
                                 <div
                                   class="grid grid-cols-3 gap-4 text-sm mt-4 text-primary_Text_Color"
                                 >
                                   <div
                                     class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                                     [title]="r?.employeeResponseDTO?.recommendedBy || 'N/A'"
                                   >
                                     {{ r?.employeeResponseDTO?.recommendedBy || "N/A" }}
                                   </div>
                                   <div
                                     class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                                     [title]="r?.employeeResponseDTO?.recommendedForPmEmail[0] || 'N/A'"
                                   >
                                     {{ r?.employeeResponseDTO?.recommendedForPmEmail[0] || "N/A" }}
                                   </div>
                                   <div
                                     class="w-40 text-ellipsis overflow-hidden whitespace-nowrap"
                                     [title]="r?.employeeResponseDTO?.recommendedOn | date: 'dd/MM/yyyy'"
                                   >
                                     {{ r?.employeeResponseDTO?.recommendedOn | date: "dd/MM/yyyy" }}
                                   </div>
     
                                   <div
                                     class="col-span-3 border-t border-card_Bg_Color"
                                   ></div>
                                 </div>
                               </div>
                             </div>
                         </div>
                         <!-- Manual icon and Score badge on right -->
                         <div class="flex items-center gap-3">
                           <!-- Score badge -->
                           <div 
                           class="ai-match-badge inline-flex items-center gap-2 text-sm rounded-full px-3 py-0.5 poppinsRegular text-primary_Text_Color ring-1 cursor-pointer"
                           [ngClass]="scoreBadgeClass(r.candidate?.score)"
                           (click)="openCalculationDetailsPopup(r)"
                           (keydown.enter)="openCalculationDetailsPopup(r)"
                           (keydown.space)="$event.preventDefault(); openCalculationDetailsPopup(r)"
                           role="button"
                           tabindex="0"
                           [attr.aria-describedby]="'candidate-ai-match-tooltip-' + i"
                         >
                            <ng-container  *ngIf="r?.employeeResponseDTO?.isManualMatching;else withoutManualMatch">
                              <img 
                             [src]="_commonServices.Images.PERSON_ICON_MANUAL_MATCHED"
                             alt="Manually Mapped"
                           />
                            </ng-container>
                            <ng-template #withoutManualMatch>
                              <span>{{ r.candidate.score | number: '1.0-2' }}%</span>
                           </ng-template>
                           <img *ngIf="!r?.employeeResponseDTO?.isManualMatching" [src]="_commonServices.Images.INFO_CIRCLE" alt="" class="w-4" />

                           <span
                             class="ai-match-tooltip border text-black border-card_number_color poppinsRegular"
                             [id]="'candidate-ai-match-tooltip-' + i"
                             role="tooltip"
                           >
                             View Calculation Logic
                             <span class="ai-match-tooltip__arrow" aria-hidden="true"></span>
                           </span>
                         </div>
                         </div>
                       </div>  
                      <div class="flex flex-col gap-2 mt-2 text-slate-500 font-medium">
                      <!-- Top Row -->
                      <div class="flex items-center text-xs   gap-2 poppinsMedium text-secondary_Light_Text_Color">
                        <ng-container *ngFor="let item of r.basicInfoColumn1; let last = last">
                          <span>{{ item }}</span>
                          <span *ngIf="!last" class="w-1.5 h-1.5 rounded-full bg-slate-300"></span>
                        </ng-container>
                      </div>
  
                      <!-- Bottom Row -->
                      <div class="flex items-center text-xs gap-2 poppinsMedium text-secondary_Light_Text_Color">
                        <ng-container *ngFor="let item of r.basicInfoColumn2; let last = last">
                          <span>{{ item }}</span>
                          <span *ngIf="!last" class="w-1.5 h-1.5 rounded-full bg-slate-300"></span>
                        </ng-container>
                      </div>
                    </div>
                     </div> 
                   </div>
                        <!-- <div class="flex items-start gap-3">
                          <div
                            class="grid size-12 shrink-0 place-items-center rounded-full bg-slate-100 text-slate-600 text-sm font-semibold ring-1 ring-slate-200 overflow-hidden"
                          >
                            <img
                              *ngIf="r.candidate.avatar"
                              [src]="r.candidate.avatar"
                              class="size-12 object-cover"
                            />
                            <span *ngIf="!r.candidate.avatar">{{
                              r.candidate.initials
                            }}</span>
                          </div>
                          <div class="min-w-0">
                            <div class="flex items-center gap-2">
                              <h3
                                class="text-lg font-semibold text-primary_Text_Color max-w-36 truncate whitespace-nowrap overflow-hidden text-ellipsis"
                                [title]="r.candidate.name"
                              >
                                {{ r.candidate.name }}
                              </h3>
  
                              <div *ngIf="r?.employeeResponseDTO.isRecommendedToPM"  class="relative inline-block">
                                <svg
                                  class="h-6 w-6 text-amber-400 cursor-pointer"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M12 17.3l-5.563 3.277 1.47-6.25L3 9.923l6.406-.547L12 3.5l2.594 5.876 6.406.547-4.907 4.404 1.47 6.25z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div
                              class="text-xs text-slate-500 mt-1 poppinsMedium"
                            >
                              {{ r.candidate.title }}
                            </div>
                          </div>
  
                          <div  (click)="openCalculationDetailsPopup(r)"
                            class="inline-flex ml-auto gap-1.5 rounded-full px-3 py-1 text-xs font-normal text-primary_Text_Color ring-1 cursor-pointer my-auto"
                            [ngClass]="scoreBadgeClass(r.candidate?.score)"
                            title="View Calculation Logic"
                          >
                            <span>{{ r.candidate.score }}%</span>
                            <img
                              [src]="_commonServices.Images.INFO_CIRCLE"
                              alt=""
                            />
                          </div>
                        </div> -->
  
                        <!-- <div
                          class="grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-6 mt-6"
                        >
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Fractal ID
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{ header.empCode ? header.empCode : "N/A" }}
                            </div>
                          </div>
  
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Grade
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{ r?.grade ? r?.grade : "N/A" }}
                            </div>
                          </div>
  
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Ageing
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{ r?.employeeResponseDTO?.ageing ? r?.employeeResponseDTO?.ageing : "N/A" }}
                            </div>
                          </div>
  
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Years of Experience
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{
                                r.candidate.experience
                                  ? r.candidate.experience
                                  : "N/A"
                              }}
                            </div>
                          </div>
  
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Location
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{ r?.employeeResponseDTO.city ? r?.employeeResponseDTO.city : "N/A" }}
                            </div>
                          </div>
  
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Cost centre
                            </div>
                            <div
                              class="mt-0.5 text-xs font-semibold text-primary_Text_Color"
                            >
                              {{ r.employeeResponseDTO.costCentre ? r.employeeResponseDTO.costCentre : "N/A" }}
                            </div>
                          </div>
                        </div> -->
  
                        <!-- Aimatching ui design for ai insights summary starts -->
                        <div class="flex flex-col h-full">
                          <div class="mt-3">
                            <p class="text-xxs poppinsMedium text-inactive_status_text mb-1">AI Insight</p>
                            <ng-container *ngIf="r?.insights; else noInsight">
                              <p
                                class="text-primary_Text_Color poppinsMedium text-xs leading-snug transition-all duration-300"
                              >
                                {{ expandedInsightCards.has(r.employeeResponseDTO.employeeId) ? r?.insights : getPreviewText(r?.insights, 30) }}
                              </p>
                            </ng-container>
                            <ng-template #noInsight>
                              <p class="text-primary_Text_Color poppinsMedium text-xs">N/A</p>
                            </ng-template>
                          </div>
                          <ng-container *ngIf="r?.insights && hasMoreWords(r?.insights, 30)">
                            <button
                              (click)="$event.stopPropagation(); toggleInsightExpand(r.employeeResponseDTO.employeeId)"
                              class="text-[#A0AABF] w-fit text-sm mt-1 hover:text-gray-500 transition-colors cursor-pointer text-left"
                            >
                              <span class="underline text-xxs poppinsMedium decoration-1 underline-offset-2">
                                {{ expandedInsightCards.has(r.employeeResponseDTO.employeeId) ? '-View Less' : '+View More' }}
                              </span>
                            </button>
                          </ng-container>
                        </div>
                        <!-- Aimatching ui design for ai insights summary ends -->
                      </div>
                    </div>
  
                    <!-- Right insights + actions -->
                    <div class="col-span-12 md:col-span-7">
                      <div
                      [ngClass]="isCardDisabled(r.employeeResponseDTO)?'bg-[#EAEBEF]':'bg-white'"
                        class="border-l border-card_Bg_Color  px-4"
                      >
                      <div class="flex items-start gap-4">
                          <!-- Bot Assessments -->
                          <div>
                            <div class="text-xxs text-inactive_status_text">
                              Bot Assessments
                            </div>
                            <div class="flex gap-2 mt-2">
                               <span class="relative inline-block" #triggerDebriefBot="cdkOverlayOrigin" cdkOverlayOrigin>
                                  <!-- /* [ngClass]="r?.isDebriefAttempted ? 'text-primary_Bg_Button_Color border border-card_Bg_Color' : 'text-[#F00] border border-card_Bg_Color' " */ -->
                                 <span
                           (mouseenter)="showCommonHover(r.srId,'DEBRIEF_BOT')"
                             (mouseleave)="scheduleCommonHide()"
                             class="text-xxs rounded-full cursor-pointer px-4 py-1 flex items-center gap-1.5"
                               [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { 'background-color': '#D4D8DE' } : null"
                             [ngClass]="isCardDisabled(r.employeeResponseDTO) ? 'text-[#64748B]  border border-card_Bg_Color' : (r?.isDebriefAttempted ? 'text-primary_Bg_Button_Color border border-card_Bg_Color' : 'text-[#F00] border border-card_Bg_Color') "
                           >
                             <img
                               [src]="c?.isDebriefAttempted ? _commonServices.Images.BLUE_TICK_ICON : _commonServices.Images.RED_CROSS"
                               alt="Bot Assessment"
                               [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { filter: 'grayscale(1) saturate(0) brightness(0.75)' } : null"
                             />
                             Debrief
                           </span>
                           <ng-template
                                    cdkConnectedOverlay
                                    [cdkConnectedOverlayOrigin]="triggerDebriefBot"
                                    [cdkConnectedOverlayOpen]="(commonHoverForId === r.srId) && (typeOfBot === 'DEBRIEF_BOT')"
                                    [cdkConnectedOverlayOffsetY]="-10"
                                    [cdkConnectedOverlayPositions]="[
                                      {
                                        originX: 'center',
                                        originY: 'top',
                                        overlayX: 'center',
                                        overlayY: 'bottom'
                                      },
                                      {
                                        originX: 'center',
                                        originY: 'bottom',
                                        overlayX: 'center',
                                        overlayY: 'top'
                                      }
                                    ]"
                                  >
                                    <div
                                      class="w-64 rounded-xl hoverShadowOnDropdown bg-white  border border-card_number_color p-5 poppinsMedium text-xs text-center pointer-events-auto relative"
                                      (mouseenter)="cancelCommonHide()"
                                      (mouseleave)="scheduleCommonHide()"
                                    >
                                      <div
                                        class="absolute left-1/2 -translate-x-1/2 -bottom-1 h-3 w-3 rotate-45 bg-white ring-1 ring-black/5"
                                      ></div>

                                      <!-- Content -->
                                      <div class="text-primary_Text_Color border-b  pb-2">
                                        Last Assigned on :
                                        <span>{{
                                          r.debriefLastAssignedOn != null ? (r.debriefLastAssignedOn | date: "dd/MM/yyyy") : 'N/A'
                                        }}</span>
                                      </div>
                                      
                                      <div class="text-primary_Text_Color border-b  pb-2 mt-3">
                                        Last taken on :
                                        <span >{{
                                          r.debriefLastTakenOn != null ? (r.debriefLastTakenOn | date: "dd/MM/yyyy") : 'N/A'
                                        }}</span>
                                      </div>

                                      <div class="group relative inline-flex w-full">
                                        <button
                                          [disabled]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR' " 
                                          [ngClass]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'  ?'cursor-not-allowed':'cursor-pointer'"
                                          type="button"
                                          class="mt-4 w-full rounded-lg bg-primary_Bg_Button_Color text-white py-2.5 shadow-sm"
                                          (click)="
                                            $event.stopPropagation();
                                            reAssignAssessment(r, 'DEBRIEF')
                                          "
                                        >
                                          Assign  Re-debrief bot
                                        </button>
                                            <div
                                                *ngIf="loginUser.userRole === 'VISITOR'"
                                                role="tooltip" class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-2/5 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
                                                <div class="flex items-start gap-3">
                                                  <div>
                                                    <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                                      View Access does not have action controls.
                                                    </p>

                                                    <p class="mt-0.5 text-xs text-gray-400">
                                                      Please contact admin for support.
                                                    </p>
                                                  </div>
                                                </div>

                                                <!-- Tooltip Arrow -->
                                                <div
                                                  class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                                ></div>
                                            </div>
                                          </div>
                                    </div>
                                  </ng-template>
  
                                  <!-- Hover modal -->
  
                               </span>
  
                                <span class="relative inline-block" #triggerPracticeBot="cdkOverlayOrigin" cdkOverlayOrigin>
                                  <span
                                    [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { 'background-color': '#D4D8DE' } : null"
                                    [ngClass]="isCardDisabled(r.employeeResponseDTO) ? 'text-[#64748B] border border-card_Bg_Color' : (r?.isPracticeBotAttempted ? 'text-primary_Bg_Button_Color border border-card_Bg_Color' : 'text-[#F00] border border-card_Bg_Color')"
                                    (mouseenter)="showCommonHover(r.srId,'INTERVIEW_BOT')"
                                    (mouseleave)="scheduleCommonHide()"
                                    class="text-xxs text-nowrap  rounded-full px-4 py-1 flex items-center gap-1.5 cursor-pointer"
                                  >
                                    <img
                                      [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { filter: 'grayscale(1) saturate(0) brightness(0.75)' } : null"
                                      [src]="r.isPracticeBotAttempted ? _commonServices.Images.BLUE_TICK_ICON : _commonServices.Images.RED_CROSS"
                                      alt="Bot Assessment"
                                    />
                                    Interview bot
                                  </span>

                                  <!-- Hover modal handled strictly by CDK Overlay -->
                                  <ng-template
                                    cdkConnectedOverlay
                                    [cdkConnectedOverlayOrigin]="triggerPracticeBot"
                                    [cdkConnectedOverlayOpen]="(commonHoverForId === r.srId) && (typeOfBot === 'INTERVIEW_BOT')"
                                    [cdkConnectedOverlayOffsetY]="-10"
                                    [cdkConnectedOverlayPositions]="[
                                      {
                                        originX: 'center',
                                        originY: 'top',
                                        overlayX: 'center',
                                        overlayY: 'bottom'
                                      },
                                      {
                                        originX: 'center',
                                        originY: 'bottom',
                                        overlayX: 'center',
                                        overlayY: 'top'
                                      }
                                    ]"
                                  >
                                    <div
                                      class="w-64 rounded-xl bg-white hoverShadowOnDropdown border border-card_number_color p-5 poppinsMedium text-xs text-center pointer-events-auto relative"
                                      (mouseenter)="cancelCommonHide()"
                                      (mouseleave)="scheduleCommonHide()"
                                    >
                                      <div
                                        class="absolute left-1/2 -translate-x-1/2 -bottom-1 h-3 w-3 rotate-45 bg-white ring-1 ring-black/5"
                                      ></div>

                                      <!-- Content -->
                                      <div class="primary_Text_Color border-b card_Bg_Color pb-2">
                                        Last Assigned on :
                                        <span>{{
                                          r.practiceBotLastAssignedOn != null ? (r.practiceBotLastAssignedOn | date: "dd/MM/yyyy") : 'N/A'
                                        }}</span>
                                      </div>
                                      
                                      <div class="primary_Text_Color border-b card_Bg_Color pb-2 mt-3">
                                        Last taken on :
                                        <span >{{
                                          r.practiceBotLastTakenOn != null ? (r.practiceBotLastTakenOn | date: "dd/MM/yyyy") : 'N/A'
                                        }}</span>
                                      </div>
                                      <div class="group relative inline-flex w-full">
                                            <button
                                            [disabled]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'" 
                                            [ngClass]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'  ?'cursor-not-allowed':'cursor-pointer'"
                                            type="button"
                                            class="mt-4 w-full rounded-lg bg-primary_Bg_Button_Color text-white py-2.5 shadow-sm"
                                            (click)="
                                              $event.stopPropagation();
                                              reAssignAssessment(r, 'PRACTICE')
                                            "
                                          >
                                            Assign Re-Interview bot
                                          </button>
                                            <div
                                                *ngIf="loginUser.userRole === 'VISITOR'"
                                                role="tooltip" class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-2/5 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
                                                <div class="flex items-start gap-3">
                                                  <div>
                                                    <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                                      View Access does not have action controls.
                                                    </p>

                                                    <p class="mt-0.5 text-xs text-gray-400">
                                                      Please contact admin for support.
                                                    </p>
                                                  </div>
                                                </div>

                                                <!-- Tooltip Arrow -->
                                                <div
                                                  class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                                ></div>
                                            </div>
                                        </div>
                                      
                                    </div>
                                  </ng-template>
                                </span>
                            </div>
                          </div>
  
                          <!-- Iqigai Assessment -->
                          <div>
                          <div class="text-xxs text-inactive_status_text">
                            Iqigai Assessment
                          </div>
                          <div class="flex gap-2 mt-2">
                            <!-- 1. Assign cdkOverlayOrigin to track the trigger element reference (#trigger="cdkOverlayOrigin") -->
                            <span class="relative inline-block" #triggerForCommon="cdkOverlayOrigin" cdkOverlayOrigin>
                              <span
                                [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { 'background-color': '#D4D8DE' } : null"
                                [ngClass]="isCardDisabled(r.employeeResponseDTO) ? 'text-[#64748B] border border-card_Bg_Color' : (r?.isAllAssessmentCompleted ? 'text-primary_Bg_Button_Color border border-card_Bg_Color' : 'text-[#F00] border border-card_Bg_Color')" 
                                class="text-xxs rounded-full px-4 py-1 flex items-center gap-1.5 cursor-pointer"
                                (mouseenter)="showCommonHover(r.srId, 'COMMON_ASSESSMENTS')"
                                (mouseleave)="scheduleCommonHide()"
                                title="Common assessment details"
                              >
                                <img
                                  [src]="r.isAllAssessmentCompleted ? _commonServices.Images.BLUE_TICK_ICON : _commonServices.Images.RED_CROSS"
                                  alt="Bot Assessment"
                                  [ngStyle]="isCardDisabled(r.employeeResponseDTO) ? { filter: 'grayscale(1) saturate(0) brightness(0.75)' } : null"
                                />
                                Common
                              </span>

                              <!-- 2. Connected Overlay Template (Renders securely at the document root level) -->
                              <ng-template
                                cdkConnectedOverlay
                                [cdkConnectedOverlayOrigin]="triggerForCommon"
                                [cdkConnectedOverlayOpen]="(commonHoverForId === r.srId) && (typeOfBot =='COMMON_ASSESSMENTS')"
                                [cdkConnectedOverlayOffsetY]="-10"
                                [cdkConnectedOverlayPositions]="[
                                  {
                                    originX: 'center',
                                    originY: 'top',
                                    overlayX: 'center',
                                    overlayY: 'bottom'
                                  },
                                  {
                                    originX: 'center',
                                    originY: 'bottom',
                                    overlayX: 'center',
                                    overlayY: 'top'
                                  }
                                ]"
                              >
                                <div
                                  class="w-64 rounded-xl bg-white hoverShadowOnDropdown border border-card_number_color p-5 poppinsMedium text-xs text-center pointer-events-auto relative"
                                  (mouseenter)="cancelCommonHide()"
                                  (mouseleave)="scheduleCommonHide()"
                                >
                                  <div
                                    class="absolute left-1/2 -translate-x-1/2 -bottom-1 h-3 w-3 rotate-45 bg-white ring-1 ring-black/5"
                                  ></div>

                                  <!-- Content per your mock -->
                                  <div class="text-primary_Text_Color  border-b  pb-2">
                                    Last Assigned on :
                                    <span >{{
                                      r.assessmentLastAssignedOn != null ? (r.assessmentLastAssignedOn | date: "dd/MM/yyyy") : 'N/A'
                                    }}</span>
                                  </div>
                                  <div class="text-primary_Text_Color border-b  pb-2 mt-3">
                                    Last taken on :
                                    <span >{{
                                      r.assessmentLastTakenOn != null ? (r.assessmentLastTakenOn | date: "dd/MM/yyyy") : 'N/A'
                                    }}</span>
                                  </div>

                                  <div class="group relative inline-flex w-full">
                                    <button
                                      [disabled]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'" 
                                      [ngClass]="isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'  ?'cursor-not-allowed':'cursor-pointer'"
                                      type="button"
                                      class="mt-4 w-full rounded-lg bg-primary_Bg_Button_Color text-white py-2.5 shadow-sm"
                                      (click)="
                                        $event.stopPropagation();
                                        reAssignAssessment(r, 'ASSESSMENT')
                                      "
                                    >
                                      Assign Re-assessment
                                    </button>
                                      <!-- Tooltip Container -->
                                      <div
                                        *ngIf="loginUser.userRole === 'VISITOR'"
                                        role="tooltip"
                                        class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-2/5 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
                                      >
                                        <div class="flex items-start gap-3">
                                          <div>
                                            <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                              View Access does not have action controls.
                                            </p>
                                            <p class="mt-0.5 text-xs text-gray-400">
                                              Please contact admin for support.
                                            </p>
                                          </div>
                                        </div>

                                        <!-- Tooltip Arrow -->
                                        <div
                                          class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                        ></div>
                                      </div>
                                    </div>
                                </div>
                              </ng-template>

                            </span>
                          </div>
                        </div>
  
                          <div
                          *ngIf="isPMViewNavigation"
                      class="ml-auto inline-flex justify-end flex-shrink-0 poppinsMedium"
                    >
                      <ng-container [ngSwitch]="getCandidateState(r.employeeResponseDTO)">
                        <p
                          *ngSwitchCase="'SELECTED'"
                          class="inline-flex items-center rounded-full px-4 py-1 text-xs font-normal bg-green-50 text-[#2E7D32] border border-[#2E7D32]"
                        >
                          Selected
                        </p>
  
                        <p
                          *ngSwitchCase="'BLOCKED'"
                          class="inline-flex items-center rounded-full px-4 py-1 text-xs font-normal bg-blue-50 text-[#1D49C4] border border-[#1D49C4]"
                        >
                          Blocked
                        </p>
  
                        <p
                          *ngSwitchCase="'RECOMMENDED'"
                          class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs text-primary_Text_Color bg-[#FEF6CC] border border-[#FCD300]"
                        >
                          <svg
                            class="h-5 w-5 text-amber-400"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              d="M12 17.3l-5.563 3.277 1.47-6.25L3 9.923l6.406-.547L12 3.5l2.594 5.876 6.406.547-4.907 4.404 1.47 6.25z"
                            />
                          </svg>
                          Recommended
                        </p>
                      </ng-container>
                    </div>
                        </div>
  
                        <!-- <div
                          class="text-xs font-medium text-secondary_Light_Text_Color"
                        >
                          AI Insights
                        </div> -->
                        <!-- <div class="mt-2 flex flex-wrap gap-2" >
                          <ng-container
                            *ngFor="let chip of r.insights | slice: 0 : 5"
                          >
                            <span class="chip">{{ chip }}</span>
                          </ng-container>
                          <span  
                          (click) ="openAiInsightModal('insights', r)"
                            *ngIf="r.insights?.length > 5"
                            class="candidate-details-chip chip-outline cursor-pointer font-semibold"
                          >
                            +{{ r.insights.length - 5 }}
                          </span>
                        </div> -->
  
                        <!-- <div
                          class="mt-4 text-xs font-medium text-secondary_Light_Text_Color"
                        >
                          Gaps
                        </div>
                        <div class="mt-2 flex flex-wrap gap-2" >
                          <ng-container *ngFor="let gap of r.gaps | slice: 0 : 3">
                            <span class="chip">{{ gap }}</span>
                          </ng-container>
                          <span (click) ="openAiInsightModal('gaps', r)"
                            *ngIf="r.gaps?.length > 3"
                            class="candidate-details-chip chip-outline cursor-pointer font-semibold"
                          >
                            +{{ r.gaps.length - 3 }}
                          </span>
                        </div> -->
                        <!-- Aimatching ui design for gaps summary starts -->
                            <div class="flex flex-col h-full">
                              <div class="mt-9 flex-1">
                                <p class="text-xxs poppinsMedium text-inactive_status_text mb-1">Gaps</p>
                                <ng-container *ngIf="r?.gaps; else noGaps">
                                  <p
                                    class="text-primary_Text_Color poppinsMedium text-xs leading-snug transition-all duration-300"
                                  >
                                 {{ expandedInsightCards.has(r.employeeResponseDTO.employeeId) ? r.gaps : getPreviewText(r.gaps, 30) }}
                                  </p>
                                </ng-container>
                                <ng-template #noGaps>
                                  <p class="text-primary_Text_Color poppinsMedium text-xs">N/A</p>
                                </ng-template>
                              </div>
                              <ng-container *ngIf="r?.gaps && hasMoreWords(r.gaps, 30)">
                                <button
                                  (click)="$event.stopPropagation(); toggleInsightExpand(r.employeeResponseDTO.employeeId)"
                                  class="text-[#A0AABF] w-fit text-sm mt-4 hover:text-gray-500 transition-colors cursor-pointer text-left"
                                >
                                  <span class="underline   text-xxs poppinsMedium decoration-1 underline-offset-2">
                                    {{ expandedInsightCards.has(r.employeeResponseDTO.employeeId) ? '-View Less' : '+View More' }}
                                  </span>
                                </button>
                              </ng-container>
                            </div>
                        <!-- Aimatching ui design for gaps summary ends -->
  
                        <div class="mt-4 flex flex-wrap items-center justify-end gap-2">
                          <!-- Options dropdown -->
                          <div class="relative" (keydown.escape)="closeAll()" (appOutsideClick)="closeAll()">
                            <div class="group relative inline-flex w-full">
                                  <button
                                  type="button"
                                  [ngClass]=" openOptionsMenu && (visibleActions && visibleActions.length > 0) ?'!border-primary_Bg_Button_Color':''"
                                  class="inline-flex items-center hoverShadow gap-2 rounded-lg border border-card_Bg_Color bg-white px-5 py-2 text-xs text-primary_Text_Color shadow-sm focus:outline-none"
                                  (click)="onToggleOptionsMenu(r)"
                                  [disabled]="isOptionsDisabled(r) || loginUser.userRole=='VISITOR'"
                                  aria-haspopup="menu"
                                  [attr.aria-expanded]="openOptionsMenu"
                                >
                                  <span>Options</span>
                                  <img [src]="openOptionsMenu ? _commonServices.Images.DROPDOWN_ICON_NEW_UX_HOVER_PRIMARY_BLUE_THEME : _commonServices.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown"  />
                                </button>
                                <!-- Tooltip Container -->
                                <div
                                  *ngIf="loginUser.userRole === 'VISITOR'"
                                  role="tooltip"
                                  class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-1/2 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
                                >
                                  <div class="flex items-start gap-3">
                                    <div>
                                      <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                        View Access does not have action controls.
                                      </p>
                                      <p class="mt-0.5 text-xs text-gray-400">
                                        Please contact admin for support.
                                      </p>
                                    </div>
                                  </div>

                                  <!-- Tooltip Arrow -->
                                  <div
                                    class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                  ></div>
                                </div>
                              </div>
                            
  
                            <!-- Options Dropdown -->
                             <div  *ngIf="openOptionsMenu" role="menu" aria-label="Actions">
                               <div 
                                 class="absolute top-full right-0 mt-2 min-w-[240px] bg-white rounded-lg border border-card_number_color hoverShadowOnDropdown overflow-hidden z-20">
                                  <ng-container *ngIf="visibleActions && visibleActions.length > 0; else noOptionsTemplate">
                                    <button
                                      type="button"
                                      *ngFor="let action of visibleActions; let first = first"
                                      (click)="onAction(r, action.key)"
                                      class="w-full text-left px-4 py-2 text-my_profile_secondary_text hover:text-primary_Text_Color hover:bg-periwinkle_mist text-xs  poppinsMedium transition-colors"
                                      [ngClass]="{
                                        'mt-2': first
                                      }">
                                      {{ action.label }}
                                    </button>
                                  </ng-container>
                                  <ng-template #noOptionsTemplate>
                                   <div class="item disabled" role="menuitem">
                                     SR is closed. No further actions available.
                                   </div>
                                 </ng-template>
                               </div>
                            </div>
  
                            <!-- <div
                              *ngIf="openOptionsMenu"
                              class="options-pop absolute right-0 z-50 bottom-full mb-2 w-[250px]"
                              role="menu"
                              aria-label="Actions"
                            >
                              <span
                                class="caret absolute -bottom-1.5 right-6 block h-3 w-3 rotate-45 bg-white"
                              ></span>
  
                              <div
                                class="panel relative rounded-2xl border border-card_Bg_Color bg-white p-1.5 shadow"
                              >
                              <ng-container *ngIf="visibleActions && visibleActions.length > 0; else noOptionsTemplate">
                                <ng-container
                                  *ngFor="
                                    let action of visibleActions;
                                    let i = index
                                  "
                                >
                                  <button
                                    class="item"
                                    role="menuitem"
                                    (click)="onAction(r, action.key)"
                                  >
                                    {{ action.label }}
                                  </button>

                                  <div
                                    *ngIf="i !== visibleActions.length - 1"
                                    class="sep"
                                  ></div>
                                </ng-container>
                              </ng-container>
                             
                              <ng-template #noOptionsTemplate>
                                <div class="item disabled" role="menuitem">
                                  SR is closed. No further actions available.
                                </div>
                              </ng-template>
                              </div>
                            </div> -->
                          </div>
                         <ng-container *ngIf="!r?.employeeResponseDTO.isRecommendedToPM;else rejectRecommended" >
                           <div class="group relative inline-flex">
                                <button  (click)="recommendToPmFunc(r)"
                                type="button"
                                class="inline-flex items-center gap-2 rounded-lg px-5 py-2 text-xs shadow-sm focus:outline-none border border-card_Bg_Color bg-primary_Bg_Button_Color text-white"
                                [disabled]="isRecommendToPmDisabled(r) || loginUser.userRole=='VISITOR'"
                              >
                                <img
                                  [src]="
                                    _commonServices.Images.RECOMMENDED_WHITE_ICON
                                  "
                                  alt="Recommend"
                                />
                                <span>Recommend to PM</span>
                              </button>
                                <!-- Tooltip Container -->
                                <div
                                  *ngIf="loginUser.userRole === 'VISITOR'"
                                  role="tooltip"
                                  class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-1/2 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
                                >
                                  <div class="flex items-start gap-3">
                                    <div>
                                      <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                        View Access does not have action controls.
                                      </p>
                                      <p class="mt-0.5 text-xs text-gray-400">
                                        Please contact admin for support.
                                      </p>
                                    </div>
                                  </div>

                                  <!-- Tooltip Arrow -->
                                  <div
                                    class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                  ></div>
                                </div>
                            </div>
                           
                           
                         </ng-container>
                         <ng-template #rejectRecommended>
                                  <!-- /* [ngClass]="
                                    selectedCandidateIds?.size == 0
                                      ? 'bg-slate-100 text-primary_Text_Color border-2 border-gray-500 border-dashed py-1.5'
                                      : 'text-white bg-primary_Bg_Button_Color py-2'
                                  " */ -->
                                   <div class="group relative inline-flex">
                                      <button
                                        type="button"
                                        class="inline-flex text-white bg-primary_Bg_Button_Color py-2  items-center gap-2 rounded-lg px-5 text-xs shadow-sm focus:outline-none poppinsMedium"
                                        [disabled]="selectedCandidateIds?.size == 0 || isCardDisabled(r.employeeResponseDTO) || loginUser.userRole=='VISITOR'"
                                        (click)="openRejectRecommendedPopup(r)"
                                      >
                                        <span>Reject Recommendation</span>
                                      </button>
                                      <!-- Tooltip Container -->
                                      <div
                                        *ngIf="loginUser.userRole === 'VISITOR'"
                                        role="tooltip"
                                        class="pointer-events-none invisible absolute bottom-[calc(100%+12px)] left-1/2 z-50 w-max max-w-[320px] -translate-x-1/2 translate-y-2 rounded-xl border border-primary_Text_Color bg-primary_Text_Color px-4 py-3 text-white opacity-0 shadow-2xl backdrop-blur-md transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
                                      >
                                        <div class="flex items-start gap-3">
                                          <div>
                                            <p class="whitespace-nowrap text-xs font-semibold leading-5">
                                              View Access does not have action controls.
                                            </p>
                                            <p class="mt-0.5 text-xs text-gray-400">
                                              Please contact admin for support.
                                            </p>
                                          </div>
                                        </div>

                                        <!-- Tooltip Arrow -->
                                        <div
                                          class="absolute left-1/2 top-full h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border-b border-r border-primary_Text_Color bg-primary_Text_Color"
                                        ></div>
                                      </div>
                                   </div>
                              
                         </ng-template>
  
                          <button type="button"
                            class="rounded-lg bg-primary_Bg_Button_Color px-6 py-2 text-xs poppinsRegular text-white shadow tracking-wide"
                            (click)="viewProfile(r)"
                          >
                            View Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Loading indicator for infinite scroll -->
            <div *ngIf="isLoadingMore" class="flex justify-center py-4">
              <div class="text-xs text-primary_Text_Color flex items-center gap-2">
                <div class="animate-spin h-4 w-4 border-2 border-primary_Bg_Button_Color border-t-transparent rounded-full"></div>
                Loading SR's...
              </div>
            </div>
          </div>

          <button
            *ngIf="showBackToTop"
            type="button"
            class="text-xs 2xl:text-sm right-[45%] bottom-[5.5rem] back-to-top poppinsMedium cancel-button-animation"
            (click)="scrollToTop()"
            aria-label="Scroll mapped staffing requests back to the top"
          >
            <img
              class="h-4 2xl:h-5 2xl:w-5"
              [src]="_commonServices.Images.BACK_TO_TOP_ICON_NEW_UX"
              alt=""
              aria-hidden="true"
            />
            <span>Back to top</span>
          </button>
  
          
        </div>
      </ng-container>
      <ng-template #nodata>
        <div class="flex items-center justify-center mt-16 2xl:mt-24">
          <div class="text-center">
            <img [src]="_commonServices.Images.NO_RECORDS" class="mx-auto" />
            <p class="text-gray-400 mt-4">
              Oops! looks like we couldn't find any staffing requests matching your search.
            </p>
          </div>
        </div>
      </ng-template>

  
      <!-- subtle bottom fade (like a scroll bar rail) -->
      <div class="pointer-events-none h-4"></div>
    </ng-container>
    <ng-container *ngIf="displayedView=='EMPLOYEE_HISTORY'">
      <div
        #employeeHistoryScrollContainer
        class="bg-white flex flex-col h-[60vh] overflow-y-auto overflow-x-hidden w-full"
        (scroll)="onEmployeeHistoryScroll($event)"
      >
        <div class="flex flex-col gap-3  md:flex-row md:items-center md:justify-between px-4">
          <div class="bg-white w-full mt-0">
        <div
          class="bg-white rounded-xl border border-[#E4EAF0] p-6"
        >
          <!-- Progress Steps -->
          <div class="relative flex justify-between pb-4 -mx-16">
            <ng-container *ngFor="let step of steps; let i = index">
              <div class="relative flex flex-col items-center w-full">
                <div
                  *ngIf="i !== 0"
                  class="absolute top-[7px] h-[2px]"
                  style="left: calc(-40% + 2px); width: calc(100% - 50px)"
                  [ngClass]="getConnectorClass(step.key)"
                ></div>
  
                <!-- Circle -->
                <div
                  class="relative z-10 h-6 w-6 rounded-full flex items-center justify-center text-sm font-semibold"
                  [ngClass]="{
                    'bg-primary_Bg_Button_Color text-white':
                      isStepActive(step.key) || isStepCompleted(step.key),
                    'bg-gray-200 text-gray-400': isStepDisabled(step.key),
                  }"
                >
                  <ng-container
                    *ngIf="(isStepCompleted(step.key) || this.areAllSRStatsCountZero); else activeIcon"
                  >
                    <img
                      [src]="_commonServices.Images.ASSESSMENT_TICK_WHITE_ICON"
                      class="h-3 w-3"
                    />
                  </ng-container>
  
                  <ng-template #activeIcon>
                    <ng-container *ngIf="isStepActive(step.key)">
                      <img
                        [src]="_commonServices.Images.WHITE_WATCH"
                        class="h-3 w-3"
                      />
                    </ng-container>
                  </ng-template>
                </div>
  
                <span
                  class="mt-2 text-sm poppinsMedium"
                  [ngClass]="{
                    'text-[#1D49CA]': isStepActive(step.key),
                    'text-primary_Bg_Button_Color': isStepCompleted(step.key),
                    'text-gray-400': isStepDisabled(step.key),
                  }"
                >
                  {{ step.label }}
                </span>
  
                <p
                  *ngIf="step.key == 'open' && SRStatsCount?.benchStartDate!=null"
                  class="text-xs text-gray-500 poppinsRegular mt-1"
                >
                  <!-- 23rd Nov 2025 -->
                  {{ SRStatsCount?.benchStartDate | date: 'd\'th\' MMM yyyy' }}
                </p>
                <p
                  *ngIf="step.key == 'closed' && closedDateDisplay"
                  class="text-xs text-gray-500 poppinsRegular mt-1"
                >
                  {{ closedDateDisplay | date: "dd MMM yyyy" }}
                </p>
  
                <!-- <p class="h-[2px] bg-card_Bg_Color w-[90%]">
                </p> -->
              </div>
            </ng-container>
          </div>
  
          <!-- Stats Cards -->
          <!-- <div class="grid grid-cols-5 gap-6 border-t border-card_Bg_Color pt-8">
            <div class="flex items-center gap-4 stat-card">
              <img
                [src]="_commonServices.Images.CANDIDATE_GROUP_ICON"
                alt=""
                class="h-14 w-14"
              />
              <div>
                <p class="stat-count">{{ SRStatsCount?.candidatesMapped }}</p>
                <p class="stat-label">Candidates Mapped</p>
              </div>
            </div>
  
            <div class="flex items-center gap-4 stat-card">
              <img [src]="_commonServices.Images.CANDIDATE_GROUP_ICON" alt="" />
              <div>
                <p class="stat-count">
                  {{ SRStatsCount?.candidatesRecommended }}
                </p>
                <p class="stat-label">Candidates recommended</p>
              </div>
            </div>
  
            <div class="flex items-center gap-4 stat-card">
              <img [src]="_commonServices.Images.CANDIDATE_GROUP_ICON" alt="" />
              <div>
                <p class="stat-count">{{ SRStatsCount?.candidatesRejected }}</p>
                <p class="stat-label">Candidates rejected</p>
              </div>
            </div>
  
            <div class="flex items-center gap-4 stat-card">
              <img [src]="_commonServices.Images.CANDIDATE_GROUP_ICON" alt="" />
              <div>
                <p class="stat-count">{{ SRStatsCount?.candidatesBlocked }}</p>
                <p class="stat-label">Candidates blocked</p>
              </div>
            </div>
  
            <div class="flex items-center gap-4 stat-card">
              <img [src]="_commonServices.Images.CANDIDATE_GROUP_ICON" alt="" />
              <div>
                <p class="stat-count">{{ SRStatsCount?.candidatesSelected }}</p>
                <p class="stat-label">Candidates selected</p>
              </div>
            </div>
          </div> -->
          <div  class="grid grid-cols-5 gap-4 border-t border-[#E4EAF0] pt-8">
            <!-- Mapped SR's -->
            <div class="flex items-center justify-center gap-2 px-4 py-3  bg-white border border-card_number_color rounded-xl shadow-sm stat-card">
              <p class="text-lg 2xl:text-2xl poppinsSemiBold text-primary_Text_Color stat-count">{{ SRStatsCount?.candidatesMapped }}</p>
              <p class="text-xs 2xl:text-sm  text-secondary_Light_Text_Color poppinsRegular stat-label">Mapped SR’s</p>
            </div>
  
            <!-- Recommended SR's -->
            <div class="flex items-center justify-center gap-2 px-4 py-3  bg-white border border-card_number_color rounded-xl shadow-sm stat-card">
              <p class="text-lg 2xl:text-2xl poppinsSemiBold text-primary_Text_Color stat-count">{{ SRStatsCount?.candidatesRecommended }}</p>
              <p class="text-xs 2xl:text-sm  text-secondary_Light_Text_Color poppinsRegular stat-label">Recommended SR’s</p>
            </div>
  
            <!-- Rejected SR's -->
            <div class="flex items-center justify-center gap-2 px-4 py-3  bg-white border border-card_number_color rounded-xl shadow-sm stat-card">
              <p class="text-lg 2xl:text-2xl poppinsSemiBold text-primary_Text_Color stat-count">{{ SRStatsCount?.candidatesRejected }}</p>
              <p class="text-xs 2xl:text-sm  text-secondary_Light_Text_Color poppinsRegular stat-label">Rejected SR’s</p>
            </div>
  
            <!-- Blocked SR's -->
            <div class="flex items-center justify-center gap-2 px-4 py-3  bg-white border border-card_number_color rounded-xl shadow-sm stat-card">
              <p class="text-lg 2xl:text-2xl poppinsSemiBold text-primary_Text_Color stat-count">{{ SRStatsCount?.candidatesBlocked }}</p>
              <p class="text-xs 2xl:text-sm  text-secondary_Light_Text_Color poppinsRegular stat-label">Blocked SR’s</p>
            </div>
  
            <!-- Selected SR's -->
            <div class="flex items-center justify-center gap-2 px-4 py-3  bg-white border border-gray-200 rounded-xl shadow-sm stat-card">
              <p class="text-lg 2xl:text-2xl poppinsSemiBold text-primary_Text_Color stat-count">{{SRStatsCount?.candidatesSelected}}</p>
              <p class="text-xs 2xl:text-sm  text-secondary_Light_Text_Color poppinsRegular stat-label">Selected SR’s</p>
            </div>
          </div>
        </div>
  
        <!-- Employee history grid -->
        <div
          *ngIf="allEmployeeHistoryData?.length > 0; else noDataForEmployeeHistory"
          class="mt-6 overflow-x-auto bg-white"
          role="table"
          aria-label="Employee history"
        >
          <div class="min-w-[1024px] text-sm">
            <div
              class="grid  grid-cols-[minmax(160px,1.1fr)_minmax(96px,0.65fr)_minmax(150px,1fr)_minmax(190px,1.25fr)_minmax(150px,1fr)_minmax(180px,1.25fr)] items-center rounded-t-xl rounded-x-xl border border-card_number_color bg-white text-xs text-my_profile_secondary_text "
              role="row"
            >
              <div class="py-4 pl-4 text-left tracking-wider" role="columnheader">Date & Time</div>
              <div class="py-4 text-left tracking-wider " role="columnheader">SR No.</div>
              <div class="py-4 text-left tracking-wider" role="columnheader">Action</div>
              <div class="py-4 text-left tracking-wider" role="columnheader">Action By</div>
              <div class="py-4 text-left tracking-wider" role="columnheader">Action To</div>
              <div class="py-4 pr-4 text-left tracking-wider" role="columnheader">Reason</div>
            </div>

            <div role="rowgroup">
              <div
                *ngFor="let data of allEmployeeHistoryData; index as i; let isFirst = first; let isLast = last"
                [ngClass]="{
                  'rounded-b-xl': isLast
                }"
                class="grid border-b poppinsRegular grid-cols-[minmax(160px,1.1fr)_minmax(96px,0.65fr)_minmax(150px,1fr)_minmax(190px,1.25fr)_minmax(150px,1fr)_minmax(180px,1.25fr)] items-center border-x border-card_number_color bg-white text-xs hover:bg-[#F3F6FC]"
                role="row"
              >
                <div class="min-w-0 py-3" role="cell">
                  <div class="flex items-center gap-4 pl-4">
                    <span class="text-sm">
                      {{ allEmployeeHistoryData.length - i }}.
                    </span>
                    <div>
                      <p class="poppinsRegular text-gray-500">
                        {{ data?.createdOn | date: "HH:mm a" }}
                      </p>
                      <p class="text-primary_Text_Color mt-1">
                        {{ data?.createdOn | date: "dd MMM yyyy" }}
                      </p>
                    </div>
                  </div>
                </div>
  
                <div class="min-w-0" role="cell">
                  <p (click)="navigateToCandidateList(data?.srNumber)" class="text-xs poppinsMedium textBasedActions cursor-pointer">
                    {{ data?.srNumber ? data?.srNumber : "N/A" }}
                  </p>
                  <!-- <p class="text-primary_Text_Color mt-1">
                    {{ data?.candidateName ? data?.candidateName : "N/A" }}
                  </p> -->
                </div>
  
                <div class="min-w-0 poppinsRegular text-primary_Text_Color" role="cell">
                  {{ data?.action ? data?.action : "N/A" }}
                </div>
  
                <div class="min-w-0 pr-4" role="cell">
                  <p
                    class="w-full break-words poppinsRegular text-gray-500"
                    [title]="data?.actionByEmail"
                  >
                    {{ data?.actionByEmail ? data?.actionByEmail : "N/A" }}
                  </p>
  
                  <p class="text-primary_Text_Color mt-1">
                    {{ data?.actionByName ? data?.actionByName : "N/A" }}
                  </p>
                </div>
  
                <div class="min-w-0 pr-4 poppinsRegular text-primary_Text_Color" role="cell">
                  {{ data?.actionTo ? data?.actionTo : "N/A" }}
                </div>
  
                <div class="min-w-0 pr-4 poppinsRegular text-primary_Text_Color" role="cell">
                  <!-- 1. Wrapper: establishes the group and positioning context -->
                  <div class="group relative block min-w-0 cursor-help">
                    
                    <!-- 2. Original Text Element -->
                    <p class="line-clamp-2 cursor-pointer overflow-hidden text-ellipsis">
                      {{ data?.reasonForCancelRecommended || "--" }}
                    </p>
  
                    <!-- 3. Tooltip Container (Only shows if there is actual data to show) -->
                    <div 
                      *ngIf="data?.reasonForCancelRecommended"
                      class="absolute bottom-full left-0 z-[9999] mb-2 -translate-x-1/2 
                            w-max max-w-xs md:max-w-sm
                            opacity-0 invisible scale-95
                            group-hover:opacity-100 group-hover:visible group-hover:scale-100 
                            transition-all duration-200 ease-out origin-bottom
                            pointer-events-none"
                    >
                      <!-- Tooltip Content Box -->
                      <div class="relative bg-primary_Text_Color text-white text-xs font-medium px-3 py-2 rounded-lg shadow-xl border border-primary_Text_Color">
                        <!-- Allows text to wrap normally if it's really long -->
                        <p class="whitespace-normal break-words text-center">
                          {{ data?.reasonForCancelRecommended }}
                        </p>
                        
                        <!-- Tooltip Arrow (Rotated Square) -->
                        <div class="absolute -bottom-1 left-1/2 -translate-x-1/2 w-3 h-3 bg-primary_Text_Color border-b border-r border-primary_Text_Color rotate-45 rounded-sm"></div>
                      </div>
                    </div>
  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noDataForEmployeeHistory>
            <div class="flex flex-col items-center justify-center pt-4 pb-2 min-h-[200px] rounded-xl shadow-sm  bg-white">
                <p *ngIf="query==''" class="text-inactive_status_text text-base text-center mt-4 poppinsMedium">
                  Employee history will populate once an action is taken on<br />
                    the SR for any candidate. 
                </p>
                  <p *ngIf="query!=''" class="text-inactive_status_text text-base text-center mt-4 poppinsMedium">
                  Oops! Looks like we could not find any activity  <br />
                  for this candidate.
                </p>
                <img
                  [src]="_commonServices.Images.NO_RECORDS"
                  alt=""
                  class="mx-auto"
                />
            </div>
            </ng-template>
        <!-- subtle bottom fade (like a scroll bar rail) -->
        <div class="pointer-events-none h-4"></div>
      </div>
        </div>
      </div>

      <button
        *ngIf="showBackToTop"
        type="button"
        class="text-xs 2xl:text-sm right-[45%] bottom-[5rem] back-to-top poppinsMedium cancel-button-animation"
        (click)="scrollToTop()"
        aria-label="Scroll employee history back to the top"
      >
        <img
          class="h-4 2xl:h-5 2xl:w-5"
          [src]="_commonServices.Images.BACK_TO_TOP_ICON_NEW_UX"
          alt=""
          aria-hidden="true"
        />
        <span>Back to top</span>
      </button>
    </ng-container>

  </div>
</div>

<!-- tiny inline component for sort chevrons -->
<ng-template #sortIcon>
  <svg
    viewBox="0 0 24 24"
    class="size-3 text-slate-400"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M7 10l5-5 5 5H7zm0 4h10l-5 5-5-5z" />
  </svg>
</ng-template>
